import { render, staticRenderFns } from "./VInventoryHolderModal.vue?vue&type=template&id=9a47ac3c"
import script from "./VInventoryHolderModal.vue?vue&type=script&lang=js"
export * from "./VInventoryHolderModal.vue?vue&type=script&lang=js"
import style0 from "./VInventoryHolderModal.vue?vue&type=style&index=0&id=9a47ac3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports